export default __webpack_public_path__ + "static/media/warantyTemplate.65ae8101.JPG";